<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Faturas
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <div>
                <VueCtkDateTimePicker
                  v-on:callback="changeDates"
                  v-model="data_entrada"
                  class="date-picker"
                  locale="pt-BR"
                  :no-header="true"
                  :no-value-to-custom-elem="true"
                  :overlay="true"
                  :range="true"
                  :formatted="'L'"
                  :format="'YYYY-MM-DD'"
                  color="#EC6521"
                  :dark="$vuetify.theme.dark"
                  button-color="#EC6521"
                  :custom-shortcuts="labels"
                  :no-button="true"
                  :noClearButton="true"
                  :auto-close="true"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  :submit="retornoData()"
                >
                  <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                    <b class="text text-primary">
                      Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                    </b>
                  </v-btn>
                </VueCtkDateTimePicker>
              </div>
              <div class="ml-3 ui-mw_autoc" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch || loadingIntegradores"
                  :disabled="loadingSearch || loadingIntegradores"
                  @change="() => {
                    this.cliente = null
                    this.usina = null
                    getClientes()
                  }"
                  outlined
                ></v-autocomplete>
              </div>
              <div class="ml-3 ui-mw_autoc">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="cliente"
                  :items="clientes"
                  clearable
                  clear-icon="close"
                  label="Cliente"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch || loadingClientes"
                  :disabled="loadingSearch || loadingClientes"
                  @change="() => {
                    this.usina = null
                    getUsinas()
                  }"
                  outlined
                >
                </v-autocomplete>
              </div>
              <div class="ml-3 ui-mw_autoc">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="usina"
                  :items="usinas"
                  clearable
                  clear-icon="close"
                  label="Usinas"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch || loadingUsinas"
                  :disabled="loadingSearch || loadingUsinas"
                  outlined
                >
                </v-autocomplete>
              </div>
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                      <v-icon>search</v-icon>
                    </v-btn>
                  </template>
                  <span>Filtrar</span>
                </v-tooltip>
              </div>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <!-- <div class="impressao__footer impressao__footer_hr text-center">
          <p class="impressao__footer_text">Emitido através da plataforma <b>SolarMaker</b> em {{$root.Formatter.formatDate(datetime, 'L')}} {{$root.Formatter.formatDate(datetime, 'HH:mm:ss')}}</p>
        </div> -->
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Faturas</p>
          <span class="impressao__periodo"><br>Período: {{ formatDateFront(de, 'L')}} até {{formatDateFront(ate, 'L') }}</span>
        </div>
        <div v-for="(itemPai, indexPai) in dados" :key="indexPai" class="mb-3">
          <div class="text-h3 text-primary mb-2">
            {{itemPai.usi_nome}} - {{itemPai.cliente ? itemPai.cliente.cli_nome : 'Cliente Excluído'}}
          </div>
          <v-simple-table class="base_table" v-if="itemPai.faturas && itemPai.faturas.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Período
                  </th>
                  <th class="text-center">
                    Valor Faturado
                  </th>
                  <th class="text-center">
                    Energia Consumida
                  </th>
                  <th class="text-center">
                    Energia Compensada
                  </th>
                  <th class="text-center">
                    Energia Injetada
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in itemPai.faturas" :key="index">
                  <td class="text-left">{{formatDateFront(item.ucf_inicio_ciclo, 'LL')}} - {{formatDateFront(item.ucf_fim_ciclo, 'LL')}}</td>
                  <td class="text-center">{{$root.Formatter.floatToMoney(item.ucf_valor_faturado)}}</td>
                  <td class="text-center">{{item.ucf_consumida}} kWh</td>
                  <td class="text-center">{{item.ucf_energia_compensada}} kWh</td>
                  <td class="text-center">{{item.ucf_energia_injetada}} kWh</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-else>
            Nenhum dado de fatura para esta usina.
          </div>
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      user: null,
      datetime: new Date(),
      loading: true,
      loadingSearch: false,
      dados: [],
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      loadingIntegradores: false,
      integradores: [],
      integrador: '',
      clientes: [],
      loadingClientes: false,
      cliente: '',
      usinas: [],
      loadingUsinas: false,
      usina: '',
      nivelUsuarioApelido: ''
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 20%;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .impressao__periodo {
            font-size: 12px!important;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            p {
              widows: 3;
            }

            .impressao__footer {
              display: block;
            }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          // this.applyFilter()
        }
      }
    },
    applyFilter () {
      this.loading = true
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.cliente ? { cliente: this.cliente } : '',
        this.usina ? { usina: this.usina } : ''
      )
      this.$router.replace({name: 'RelatoriosFaturas', query: query}).catch(() => {})
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate, this.integrador, this.cliente, this.usina)
    },
    loadFunctions (inicio, fim, int, cli, usi) {
      let endpoint = inicio ? '?de=' + inicio : '?de='
      endpoint += fim ? '&ate=' + fim : '&ate='
      endpoint += int ? '&integrador=' + int : '&integrador='
      endpoint += cli ? '&cliente=' + cli : '&cliente='
      endpoint += usi ? '&usina=' + usi : '&usina='
      this.getFaturas(endpoint)
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.cliente) this.cliente = filters.cliente
      if (filters.usina) this.usina = filters.usina
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      if (this.nivelUsuarioApelido === 'I') {
        this.integrador = this.user.uuid_int_id
      } else {
        this.getIntegradores()
      }
      if (this.integrador) {
        this.getClientes()
      }
      if (this.cliente) {
        this.getUsinas()
      }
      this.loadFunctions(this.de, this.ate, this.integrador, this.cliente, this.usina)
    },
    async getFaturas (endpoint) {
      this.loading = true
      await Api.get('relatorios/faturas' + endpoint)
        .then(res => {
          this.dados = res.data
          console.log('Relatórios de Faturas ==>', res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os relatórios de faturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores () {
      this.loadingIntegradores = true
      await Api.get('integradores')
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getClientes () {
      if (this.integrador) {
        this.usinas = []
        this.loadingClientes = true
        await Api.get('clientes/integrador/' + this.integrador)
          .then(res => {
            var arrayCli = []
            res.data.map(cli => {
              arrayCli.push({
                'text': cli.cli_nome,
                'value': cli.uuid_cli_id
              })
            })
            this.clientes = arrayCli
            this.loadingClientes = false
          })
          .catch(err => {
            this.loadingClientes = false
            this.$root.SnackControl.open(this, {
              text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
              color: 'error'
            })
            console.log(err)
          })
      } else {
        this.clientes = []
      }
    },
    async getUsinas () {
      if (this.cliente) {
        this.loadingUsinas = true
        await Api.get('usinas/cliente/' + this.cliente)
          .then(res => {
            var arrayUsi = []
            res.data.map(usi => {
              arrayUsi.push({
                'text': usi.usi_nome,
                'value': usi.uuid_usi_id
              })
            })
            this.usinas = arrayUsi
            this.loadingUsinas = false
          })
          .catch(err => {
            this.loadingUsinas = false
            this.$root.SnackControl.open(this, {
              text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usinas!',
              color: 'error'
            })
            console.log(err)
          })
      } else {
        this.usinas = []
      }
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__footer {
  bottom: 0;
  position: fixed;
  width: 100%;
  display: none;
}
.impressao__footer_text {
  color: #d0d0d0;
  font-size: 11px;
  padding-top: 5px;
}
.impressao__footer_hr {
  margin-bottom: 10px;
}
.impressao__header {
  width: 100%;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/atendimento/Faturas.vue